import React from 'react';
import './ContractCoverageBadge.css';

const BADGE_CONFIG = {
  Current: { label: 'Valid', className: 'valid' },
  ExpiringWithin30d: { label: 'Expiring Soon', className: 'expiring' },
  Expired: { label: 'Expired', className: 'expired' },
  NotCovered: { label: 'Not Covered', className: 'not-covered' },
  InHouse: { label: 'In-house', className: 'in-house' },
};

export const ContractCoverageBadge = ({ status, size = 'medium' }) => {
  const config = BADGE_CONFIG[status];
  if (!config) return null;

  return (
    <span
      className={`contract-coverage-badge contract-coverage-${config.className} contract-coverage-badge-${size}`}
      title={`Contract status: ${config.label}`}
    >
      {config.label}
    </span>
  );
};
